<template>
  <div class="">
    <b-card no-body class="card-statistic">
      <b-card-body class="p-2">
        <b-table
          ref="refSupplierListTable"
          class="position-relative"
          :items="suppliersList"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="未找到匹配的記錄"
          :sort-desc.sync="isSortDirDesc"
        >
          <!-- Column: cost_summary -->
          <template #cell(show_details)="row">
            <b-button
              v-if="row.item.cost_summary"
              size="sm"
              @click="row.toggleDetails"
              class="mr-2"
            >
              {{ row.detailsShowing ? "隱藏" : "顯示" }}
            </b-button>
          </template>
          <template #row-details="row">
            <b-row
                class="p-2 backgroundColor5 mb-1"
                v-for="(cost, index) in row.item.cost_summary"
                :key="`cost${index}`"
              >
                <b-col cols="12" md="6">
                  <div class="row mb-50">
                    <span class="col-6">項目（{{index+1}}）：</span>
                    <span class="col-6">{{ cost.event.name }}</span>
                  </div>
                  <div v-if="cost.event.id == 1" class="row mb-50">
                    <span class="col-6">師傅名稱：</span>
                    <span class="col-6">{{ cost.supplier_name }}</span>
                  </div>
                  <div v-if="cost.event.id == 2" class="row mb-50">
                    <span class="col-6">數量：</span>
                    <span class="col-6">{{ cost.quantity }}</span>
                  </div>
                  <div class="row mb-50">
                    <span class="col-6">金額：</span>
                    <span class="col-6">{{ cost.salary }}</span>
                  </div>
                </b-col>
                <b-col cols="12" md="6">
                  <div v-if="cost.event.id == 1" class="row mb-50">
                    <span class="col-6">職位：</span>
                    <span class="col-6">{{ cost.position }}</span>
                  </div>
                  <div v-if="cost.event.id == 1" class="row mb-50">
                    <span class="col-6">開工日期：</span>
                    <pre class="col-6">{{ cost.join_date }}</pre>
                  </div>
                  <div v-if="cost.event.id == 2" class="row mb-50">
                    <span class="col-6">備註：</span>
                    <span class="col-6">{{ cost.remark }}</span>
                  </div>
                </b-col>
              </b-row>
          </template>

          <!-- Column: status -->
          <template #cell(status)="data">
              {{data.item.status.name}}
          </template>


          <template #cell(actions)="data">
            <b-dropdown
              :class="`action-trigger-btn ${
                suppliersList.length <= 3 ? 'hor' : 'ver'
              }`"
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content class="">
                <feather-icon
                  icon="EyeIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>

              <b-dropdown-item
                v-if="ability.can('read', 'approval-expenditure-supplier') || true"
                :to="{
                  name: 'approval-expenditure-supplier-view',
                  params: { id: data.item.id },
                }"
              >
                <feather-icon icon="FileTextIcon" />
                <span class="align-middle ml-50">詳細資料</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-if="ability.can('update', 'approval-expenditure-supplier') || true"
                :to="{
                  name: 'approval-expenditure-supplier-edit',
                  params: { id: data.item.id },
                }"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">修改資料</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-if="ability.can('delete', 'approval-expenditure-supplier') || true"
                @click="removeItem(index, data.item)"
              >
                <feather-icon icon="Trash2Icon" />
                <span class="align-middle ml-50">刪除記錄</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >在{{ dataMeta.of }}個記錄中，正在顯示 {{ dataMeta.from }} 至
                {{ dataMeta.to }}個記錄</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRow"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>
    
<script>
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import useSuppliersList from "./useSuppliersList";
import supplierStoreModule from "../supplierStoreModule";

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
  },
  data() {
    return {
    };
  },
  methods: {
    removeItem(index, item) {
      // check number of record
      this.$swal({
        title: "你確定嗎?",
        text: "您的決定是最終決定，您將無法取回這記錄。",
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("/approval-expenditure-supplier/deleteSupplier", { id: item.id })
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = "approval-expenditure-supplier";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, supplierStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    const {
      fetchSuppliers,
      tableColumns,
      perPage,
      currentPage,
      totalRow,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      suppliersList,
      refSupplierListTable,
      refetchData,
      ability,
    } = useSuppliersList();

    return {
      fetchSuppliers,
      tableColumns,
      perPage,
      currentPage,
      totalRow,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      suppliersList,
      refSupplierListTable,
      refetchData,
      ability,
    };
  },
};
</script>
    
<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

// @media screen and (max-width: 768px) {

// }
// @media screen and (max-width: 575px) {

// }
</style>
    
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@/assets/scss/variables/_variables.scss";
</style>
    